/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Billing_Bills_List_Col_DateInputs */

const es_admin_billing_bills_list_col_date = /** @type {(inputs: Admin_Billing_Bills_List_Col_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fecha`)
};

const en_admin_billing_bills_list_col_date = /** @type {(inputs: Admin_Billing_Bills_List_Col_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Date`)
};

/**
* | output |
* | --- |
* | "Date" |
*
* @param {Admin_Billing_Bills_List_Col_DateInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const admin_billing_bills_list_col_date = /** @type {((inputs?: Admin_Billing_Bills_List_Col_DateInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Billing_Bills_List_Col_DateInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_admin_billing_bills_list_col_date(inputs)
	return en_admin_billing_bills_list_col_date(inputs)
});
export { admin_billing_bills_list_col_date as "admin.billing.bills_list.col_date" }